import { startWorker } from "./gxworker-factory";
// import hxWorker from "./hxworker-factory";
import { startPxWorker } from "./pxworker-factory";

import { takeEvery, select } from "starfx";
import { ThunkCtx, Next } from "starfx";
import { fxDispatch } from "@app/statefx/xstore";
import { schema } from "../schema";
import { xThunk } from "../xapis";
import { db as workerDb } from "@app/stateCommon/idbSchema";
import { schemaB } from "@app/stateCommon/schemaBlue";
import { isTBlueTable } from "../routines/mapperfn";
import { sfxNotify } from "../xThunks/notify";
import { resource, call } from "starfx";
import { selectorWorkerGxDBName } from "../selectors/app.sel";
import { updateStore } from "starfx";
import { isEqual } from "lodash";
import { decodeBase64 } from "@app/service/helpers";
// export async function initHxWorker(userseed: string) {
//   hxWorker.postMessage(`idb@${userseed}`);
// }

export function WorkerStorage(store) {
  if (!store) {
    console.error("store not found 2");
    return;
  }
  const db = workerDb(store);
  return db;
}

const sfxSetExecutionQueue = xThunk.create<Record<string, any>>(
  "/sfx/sfxSetExecutionQueue",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    // this will trigger the queue to be processed
    //[findme:#807492024]//
    yield* schema.update(schema.execution.set(ctx.payload));
    yield* next();
  }
);

const sfxTextNotify = xThunk.create<Record<string, any>>(
  "/sfx/sfxTextNotify",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    yield* schema.update(schema.notify.set({ message: ctx.payload }));
    yield* next();
  }
);

const sfxSetLock = xThunk.create<Record<string, any>>(
  "/sfx/sfxSetLock",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    yield* schema.update(schema.lock.set(ctx.payload ?? null));
    yield* next();
  }
);

const setLoaderText = xThunk.create<Record<string, any>>(
  "/sfx/setLoaderText",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    yield* schema.update(schema.loaderText.set(ctx.payload));
    yield* next();
  }
);

const setBootLoaderProgress = xThunk.create<Record<string, any>>(
  "/sfx/setBootLoaderProgress",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    yield* schema.update(schema.loaderBootProgress.set(ctx.payload));
    yield* next();
  }
);

const setBootLoaderText = xThunk.create<Record<string, any>>(
  "/sfx/setBootLoaderText",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    yield* schema.update(schema.loaderBootText.set(ctx.payload));
    yield* next();
  }
);
// Function to fetch data from any table in IndexedDB
// and reduce it into an object keyed by the primary key
function* getDataByKey(dbName, storeName) {
  const db = yield* call(() => workerDb(dbName));
  const allData = yield* call(() => db.getAll(storeName));
  const blue = schemaB[storeName];
  if (!blue) {
    console.error("table not found #2", storeName);
    return;
  }
  if (isTBlueTable(blue)) {
    const primaryKey = blue.primaryKey;
    return allData.reduce((acc, item) => {
      const key = item[primaryKey];
      acc[key] = item;
      return acc;
    }, {});
  } else {
    return allData;
  }
}

function* getDataByKeyAndShard(dbName, storeName, shard) {
  const db = yield* call(() => workerDb(dbName));
  const blue = schemaB[storeName];
  if (!blue) {
    console.error("table not found #2", storeName);
    return;
  }
  if (isTBlueTable(blue)) {
    const allData = yield* call(() =>
      db.getAllFromIndex(storeName, "_hkey", shard)
    );
    const primaryKey = blue.primaryKey;
    return allData.reduce((acc, item) => {
      const key = item[primaryKey];
      acc[key] = item;
      return acc;
    }, {});
  } else {
    const allData = yield* call(() => db.getAll(storeName));
    return allData;
  }
}

const redisRehydrate = xThunk.create<string>(
  "/sfx/redisRehydrate",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    try {
      const persisted = JSON.parse(ctx.payload);
      // console.log("persisted", persisted);
      for (const perKey in persisted) {
        yield* updateStore(function (state) {
          state[perKey] = persisted[perKey];
        });
      }
    } catch (e) {
      console.error("error in redisRehydrate", e);
    }
    yield* next();
  }
);

// notes:
// general function that updates state of the given table in starfx
// based on the data in indexedDB

// further notes:

//// update the persistor needs a propper hydration from the server.

//

// export const updateReadData = xThunk.create<{
//   table: string;
// }>(
//   "/sfx/updateReadData",
//   { supervisor: takeEvery },
//   function* (ctx: ThunkCtx, next: Next) {
//     const { table } = ctx.payload;
//     try {
//       if (typeof schema[table] === "undefined") {
//         console.error("table not found #0", table);
//         return;
//       }
//     } catch (e) {
//       console.error("table not found #1", table);
//       return;
//     }
//     const indexDbName = yield* select(selectorWorkerGxDBName);
//     if (!indexDbName) {
//       console.error("indexDbName not found", indexDbName);
//       return;
//     }
//     const dataset_ = yield* call(() => getDataByKey(indexDbName, table));
//     const dataset = Object.values(dataset_);

//     if (isTBlueTable(schemaB[table])) {
//       //we have the _hkey which is a key of a shard encoding:

//         const datasetGroupped = dataset.reduce((acc, rec:any) => {
//           acc[rec._hkey] = rec._hvalue;
//           return acc;
//         }, {});

//       const main = yield* select(schema[table].selectTableAsList) as any[];
//       const mainGroupped = main.reduce((acc, rec) => {
//         acc[rec._hkey] = rec._hvalue;
//         return acc;
//       }, {});

//       // the main should be updated with the dataset
//       // but if the chunks are the same we should not update
//       if (isEqual(datasetGroupped, mainGroupped)) {
//         console.log("dataset and main are the same", table);
//         return;
//       }
//       let keysAreTheSame = true;
//       for (const key of Object.keys(datasetGroupped)) {
//         if (!mainGroupped[key]) {
//           keysAreTheSame = false;
//           break;
//         }
//       }
//       console.log("keysAreTheSame", keysAreTheSame);

//       if (keysAreTheSame) {
//         //we will update the main table with the dataset for the values that are different;
//         for (const key of Object.keys(datasetGroupped))  {
//           if (!isEqual(datasetGroupped[key], mainGroupped[key])) {
//             const keysOfMainToReplace = main
//               .filter((rec) => rec._hkey === key)
//               .map((rec) => rec[schemaB[table].primaryKey]);

//             const datasetToAdd = dataset.reduce((acc, rec:any) => {
//               if (rec._hkey === key) {
//                 acc[rec[schemaB[table].primaryKey]] = rec;
//               }
//               return acc;
//             }, {});

//             yield* schema.update([
//               schema[table].remove(keysOfMainToReplace),
//               schema[table].add(datasetToAdd),
//             ]);
//             console.log("updated shard", table, key);
//           }
//         }
//       } else {
//         // the dataset might be so different that is difficult to update cherry pick
//         // raw update the main table with the idb dataset
//         yield* schema.update([schema[table].set(dataset)]);
//         console.log("updated full A", table);
//       }
//     } else {
//       // raw update the main table with the idb dataset
//       yield* schema.update([schema[table].set(dataset)]);
//       console.log("updated full B", table);
//     }
//     yield* next();
//   }
// );

export const updateReadData = xThunk.create<{
  table: string;
  oldHKey: string | null;
}>(
  "/sfx/updateReadData",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    const { table, oldHKey } = ctx.payload;
    try {
      if (typeof schema[table] === "undefined") {
        console.error("table not found #0", table);
        return;
      }
    } catch (e) {
      console.error("table not found #1", table);
      return;
    }

    const indexDbName = yield* select(selectorWorkerGxDBName);
    if (!indexDbName) {
      console.error("indexDbName not found", indexDbName);
      return;
    }
    // we will replace the entire table with the data from indexedDB, even if it is a shard the one that is updated

    // todo: we should update only the shard that is updated

    if (oldHKey && isTBlueTable(schemaB[table])) {
      // partial update
      const dataset = yield* call(() =>
        getDataByKeyAndShard(indexDbName, table, oldHKey)
      );
      const keysToReplace = yield* select(
        schema[table].selectTableAsList
      ) as any[];
      const keysOfMainToReplace = keysToReplace
        .filter((rec) => rec._hkey === oldHKey)
        .map((rec) => rec[schemaB[table].primaryKey]);

      yield* schema.update([
        schema[table].remove(keysOfMainToReplace),
        schema[table].add(dataset),
      ]);
    } else {
      const dataset = yield* call(() => getDataByKey(indexDbName, table));
      yield* schema.update([schema[table].set(dataset)]);
    }
    yield* next();
  }
);

// this is called from login in saga-query insider - login.ts, which occurs before
// the starfx login
// don't yield inside the resouce or it will end it;
export function initGxWorker(userseed: string) {
  return resource(function* (provide) {
    //start the worker
    const gxWorker = startWorker();
    //fire-up the indexedDB connection within the worker
    gxWorker.postMessage(`idb@${userseed}`);
    //listen for messages from the worker
    gxWorker.onmessage = (e) => {
      switch (e.data.type) {
        case "hello":
          console.log("gx.worker: hello", e.data);
          break;
        case "pong":
          console.log("gx.worker: pong", e.data);
          break;
        case "/sfx/setExecutionQueue":
          fxDispatch(sfxSetExecutionQueue(e.data.payload));
          break;
        case "sfx/textNotify":
          fxDispatch(sfxTextNotify(e.data.payload));
          break;
        case "/sfx/appNotify":
          fxDispatch(sfxNotify(e.data.payload));
          break;
        case "/worker/idbready":
          fxDispatch(updateReadData(e.data.payload));
          break;
        case "SET/lock":
          fxDispatch(sfxSetLock(e.data.payload));
          break;
        case "SET/loaderText":
          fxDispatch(setLoaderText(e.data.payload));
          break;
        case "SET/loaderBootProgress":
          fxDispatch(setBootLoaderProgress(e.data.payload));
          break;
        case "SET/loaderBootText":
          fxDispatch(setBootLoaderText(e.data.payload));
          break;
        default: {
          const { type, payload, json } = e.data;
          fxDispatch({ type, payload: json ?? payload });
          if (process.env.NODE_ENV === "development") {
            console.log("[dev]. gx.worker: default action", e.data);
          }
          break;
        }
      }
    };
    yield* provide(gxWorker);
  });
}

export const initPxWorker = (userseed: string) => {
  return resource(function* (provide) {
    const pxWorker = startPxWorker();
    pxWorker.postMessage(`idb@${userseed}`);
    pxWorker.onmessage = (e) => {
      switch (e.data.type) {
        case "hello":
          console.log("px.worker: hello", e.data);
          break;
        case "pong":
          console.log("px.worker: pong", e.data);
          break;
        case "/rehydrate": {
          fxDispatch(redisRehydrate(e.data.payload));
          break;
        }
        default: {
          const { type, payload, json } = e.data;
          fxDispatch({ type, payload: json ?? payload });
          if (process.env.NODE_ENV === "development") {
            console.log("[dev]. px.worker: default action", e.data);
          }
          break;
        }
      }
    };
    yield* provide(pxWorker);
  });
};
